<div class="contextual-menu">
  <!-- global -->
  <evc-dropdown-menu
    class="contextual-menu__dropdown"
    [menuConfig]="addMenuConfig"></evc-dropdown-menu>
  <input
    type="file"
    #upload
    hidden
    multiple
    (change)="onFilesSelected()" />
</div>
